(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["site-header"] && !Shopify.designMode) return;
  try {
    (() => {
    const drawer = document.getElementById('MobileNavDrawer');
    const toggle = document.querySelector('.mobile-nav-toggle');
    const desktopNav = document.querySelector('.site-nav');
    const desktopGroups = [...document.querySelectorAll('.site-nav__item')];
    const searchPanel = document.querySelector('.site-header__search');
    const hoverQuery = window.matchMedia('(min-width: 1280px) and (hover: hover) and (pointer: fine)');
    const hoverTimers = new Map(desktopGroups.map(group => [group, { open: null, close: null }]));
    let previousFocus = null;

    const clearHoverTimers = group => {
      const timers = hoverTimers.get(group);
      window.clearTimeout(timers.open);
      window.clearTimeout(timers.close);
      timers.open = null;
      timers.close = null;
    };
    const closeGroup = group => {
      clearHoverTimers(group);
      group.open = false;
    };
    const closeDesktop = (except = null) => {
      desktopGroups.forEach(group => {
        if (group !== except) closeGroup(group);
      });
    };

    desktopGroups.forEach(group => {
      const summary = group.querySelector('summary');
      group.addEventListener('pointerenter', event => {
        if (!hoverQuery.matches || event.pointerType !== 'mouse') return;
        clearHoverTimers(group);
        if (group.open) return;
        hoverTimers.get(group).open = window.setTimeout(() => {
          const focusedGroup = desktopGroups.find(item => item.contains(document.activeElement));
          if (focusedGroup && focusedGroup !== group && document.activeElement.matches(':focus-visible')) return;
          closeDesktop(group);
          group.open = true;
          if (searchPanel) searchPanel.open = false;
        }, 180);
      });
      group.addEventListener('pointerleave', event => {
        if (event.pointerType !== 'mouse') return;
        clearHoverTimers(group);
        if (group.contains(document.activeElement) && document.activeElement.matches(':focus-visible')) return;
        hoverTimers.get(group).close = window.setTimeout(() => closeGroup(group), 320);
      });
      summary.addEventListener('pointerdown', () => clearHoverTimers(group));
      group.addEventListener('toggle', () => {
        if (group.open) {
          closeDesktop(group);
          if (searchPanel) searchPanel.open = false;
        } else {
          clearHoverTimers(group);
        }
      });
      group.addEventListener('focusout', event => {
        if (!group.contains(event.relatedTarget)) closeGroup(group);
      });
      group.addEventListener('keydown', event => {
        clearHoverTimers(group);
        if (event.key === 'Escape' && group.open) {
          event.preventDefault();
          event.stopPropagation();
          closeDesktop();
          summary.focus();
        }
      });
    });
    hoverQuery.addEventListener('change', () => closeDesktop());
    document.addEventListener('keydown', event => {
      if (event.key === 'Escape') closeDesktop();
    });
    if (searchPanel) {
      const panel = searchPanel.querySelector('.site-header__search-panel');
      const input = panel.querySelector('input[type="search"]');
      const form = panel.querySelector('form');
      const results = panel.querySelector('.site-header__search-results');
      const list = panel.querySelector('.site-header__suggestions');
      const status = panel.querySelector('[role="status"]');
      const allResults = panel.querySelector('.site-header__search-all');
      let debounceTimer;
      let controller;
      let generation = 0;
      let activeIndex = -1;
      input.setAttribute('role', 'combobox');
      input.setAttribute('aria-autocomplete', 'list');
      input.setAttribute('aria-controls', list.id);
      input.setAttribute('aria-expanded', 'false');

      const selectSuggestion = index => {
        const options = [...list.children];
        activeIndex = index;
        options.forEach((option, i) => option.setAttribute('aria-selected', String(i === index)));
        if (options[index]) {
          input.setAttribute('aria-activedescendant', options[index].id);
          options[index].scrollIntoView({ block: 'nearest', behavior: 'instant' });
        } else input.removeAttribute('aria-activedescendant');
      };
      const resetSuggestions = () => {
        generation++;
        window.clearTimeout(debounceTimer);
        if (controller) controller.abort();
        controller = null;
        selectSuggestion(-1);
        list.replaceChildren();
        list.hidden = true;
        results.hidden = true;
        status.textContent = '';
        input.setAttribute('aria-expanded', 'false');
      };
      const renderSuggestions = (products, query) => {
        const fragment = document.createDocumentFragment();
        const normalize = text => String(text).normalize('NFKD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
        const terms = normalize(query).match(/[\p{L}\p{N}]+/gu) || [];
        const isSku = /^ng[-\s]?[a-z]{2,5}[-\s]?\d{1,6}$/i.test(query);
        products.slice(0, 5).forEach(product => {
          if (typeof product.title !== 'string' || typeof product.url !== 'string') return;
          const searchable = normalize([
            product.title, product.type, product.handle,
            String(product.body || '').replace(/<[^>]*>/g, ' '),
            ...(product.variants || []).map(variant => variant.title)
          ].join(' '));
          if (!isSku && !terms.every(term => searchable.includes(term))) return;
          const url = new URL(product.url, window.location.origin);
          if (url.origin !== window.location.origin) return;
          const option = document.createElement('li');
          option.id = list.id + '-' + fragment.childElementCount;
          option.setAttribute('role', 'option');
          option.setAttribute('aria-selected', 'false');
          const link = document.createElement('a');
          link.href = url.href;
          link.tabIndex = -1;
          link.className = 'site-header__suggestion-link';
          const copy = document.createElement('span');
          copy.className = 'site-header__suggestion-copy';
          copy.textContent = product.title;
          if (product.type) {
            const type = document.createElement('span');
            type.className = 'site-header__suggestion-type';
            type.textContent = product.type;
            copy.appendChild(type);
          }
          const arrow = document.createElement('span');
          arrow.className = 'site-header__suggestion-arrow';
          arrow.setAttribute('aria-hidden', 'true');
          arrow.textContent = '→';
          link.append(copy, arrow);
          option.appendChild(link);
          fragment.appendChild(option);
        });
        list.replaceChildren(fragment);
        list.hidden = !list.children.length;
        input.setAttribute('aria-expanded', String(!list.hidden));
        status.textContent = list.children.length
          ? panel.dataset.count.replace('[count]', String(list.children.length))
          : panel.dataset.empty;
      };
      const queueSuggestions = () => {
        resetSuggestions();
        const query = input.value.trim();
        if (query.length < 2 || !searchPanel.open) return;
        const requestGeneration = generation;
        const searchUrl = new URL(form.action);
        searchUrl.searchParams.set('q', query);
        searchUrl.searchParams.set('type', 'product');
        searchUrl.searchParams.set('options[prefix]', 'last');
        allResults.href = searchUrl.href;
        results.hidden = false;
        status.textContent = panel.dataset.loading;
        debounceTimer = window.setTimeout(async () => {
          const requestController = new AbortController();
          controller = requestController;
          const timeout = window.setTimeout(() => requestController.abort(), 5000);
          try {
            const url = new URL(panel.dataset.suggestUrl, window.location.origin);
            url.searchParams.set('q', query);
            url.searchParams.set('resources[type]', 'product');
            url.searchParams.set('resources[limit]', '5');
            url.searchParams.set('resources[options][unavailable_products]', 'last');
            url.searchParams.set('resources[options][fields]', 'title,product_type,variants.title,variants.sku');
            const response = await fetch(url, { signal: requestController.signal, headers: { Accept: 'application/json' } });
            if (!response.ok) throw new Error('Search unavailable');
            const data = await response.json();
            if (requestGeneration !== generation || !searchPanel.open) return;
            const products = data.resources?.results?.products;
            if (!Array.isArray(products)) throw new Error('Invalid search response');
            renderSuggestions(products, query);
          } catch {
            if (requestGeneration === generation && searchPanel.open) status.textContent = panel.dataset.unavailable;
          } finally {
            window.clearTimeout(timeout);
            if (controller === requestController) controller = null;
          }
        }, 250);
      };
      input.addEventListener('input', event => {
        if (event.isComposing) resetSuggestions();
        else queueSuggestions();
      });
      input.addEventListener('compositionend', queueSuggestions);
      input.addEventListener('keydown', event => {
        if (event.isComposing) return;
        const count = list.children.length;
        if (count && (event.key === 'ArrowDown' || event.key === 'ArrowUp')) {
          event.preventDefault();
          const next = event.key === 'ArrowDown'
            ? (activeIndex + 1) % count : (activeIndex <= 0 ? count - 1 : activeIndex - 1);
          selectSuggestion(next);
        } else if (event.key === 'Enter' && activeIndex >= 0) {
          event.preventDefault();
          list.children[activeIndex].querySelector('a').click();
        } else if (event.key === 'Tab') selectSuggestion(-1);
      });
      form.addEventListener('submit', () => {
        window.clearTimeout(debounceTimer);
        if (controller) controller.abort();
      });
      window.addEventListener('pagehide', resetSuggestions);
      searchPanel.addEventListener('toggle', () => {
        if (searchPanel.open) {
          closeDesktop();
          input.focus();
          queueSuggestions();
        } else resetSuggestions();
      });
      searchPanel.addEventListener('focusout', event => {
        if (event.relatedTarget && !searchPanel.contains(event.relatedTarget)) searchPanel.open = false;
      });
      searchPanel.addEventListener('keydown', event => {
        if (event.key === 'Escape' && searchPanel.open) {
          event.preventDefault();
          searchPanel.open = false;
          searchPanel.querySelector('summary').focus();
        }
      });
    }
    document.addEventListener('click', event => {
      if (desktopNav && !desktopNav.contains(event.target)) closeDesktop();
      if (searchPanel && !searchPanel.contains(event.target)) searchPanel.open = false;
    });

    const drawerMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    let drawerCloseTimer = null;
    const cleanupDrawer = () => {
      window.clearTimeout(drawerCloseTimer);
      drawerCloseTimer = null;
      drawer.classList.remove('is-closing');
      document.body.classList.remove('mobile-nav-open');
      if (toggle) toggle.setAttribute('aria-expanded', 'false');
      if (previousFocus && previousFocus.isConnected) previousFocus.focus();
      previousFocus = null;
    };
    const finishDrawerClose = () => {
      window.clearTimeout(drawerCloseTimer);
      drawerCloseTimer = null;
      if (drawer && drawer.open) drawer.close();
    };
    const closeDrawer = () => {
      if (!drawer || !drawer.open || drawer.classList.contains('is-closing')) return;
      if (drawerMotion.matches) {
        finishDrawerClose();
        return;
      }
      drawer.classList.add('is-closing');
      drawerCloseTimer = window.setTimeout(finishDrawerClose, 240);
    };
    window.NexaGensMobileNav = {
      open() {
        if (!drawer || drawer.open) return;
        previousFocus = document.activeElement;
        closeDesktop();
        if (searchPanel) searchPanel.open = false;
        drawer.classList.remove('is-closing');
        drawer.showModal();
        drawer.scrollTop = 0;
        document.body.classList.add('mobile-nav-open');
        if (toggle) toggle.setAttribute('aria-expanded', 'true');
        drawer.querySelector('.mobile-nav-drawer__close').focus();
      },
      close: closeDrawer
    };
    if (drawer) {
      drawer.addEventListener('close', cleanupDrawer);
      drawer.addEventListener('cancel', event => {
        event.preventDefault();
        closeDrawer();
      });
      drawer.addEventListener('animationend', event => {
        if (event.target === drawer && event.animationName === 'nexa-drawer-out') finishDrawerClose();
      });
      drawer.addEventListener('click', event => {
        if (event.target !== drawer) return;
        const rect = drawer.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right ||
            event.clientY < rect.top || event.clientY > rect.bottom) closeDrawer();
      });
      drawer.querySelectorAll('.mobile-nav-drawer__group').forEach(group => {
        const summary = group.querySelector('summary');
        let animation = null;
        let targetOpen = group.open;
        const setGroupOpen = open => {
          const startHeight = group.getBoundingClientRect().height;
          if (animation) {
            animation.onfinish = null;
            animation.cancel();
            animation = null;
          }
          targetOpen = open;
          group.classList.toggle('is-collapsing', !open);
          if (drawerMotion.matches || !group.animate) {
            group.open = open;
            group.style.overflow = '';
            group.classList.remove('is-collapsing');
            return;
          }
          group.open = true;
          const style = getComputedStyle(group);
          const border = parseFloat(style.borderTopWidth) + parseFloat(style.borderBottomWidth);
          const endHeight = open ? group.getBoundingClientRect().height : summary.getBoundingClientRect().height + border;
          group.style.overflow = 'hidden';
          animation = group.animate([{ height: startHeight + 'px' }, { height: endHeight + 'px' }], {
            duration: 180, easing: 'ease-out'
          });
          animation.onfinish = () => {
            group.open = targetOpen;
            group.style.overflow = '';
            group.classList.remove('is-collapsing');
            animation = null;
          };
        };
        summary.addEventListener('click', event => {
          event.preventDefault();
          setGroupOpen(!targetOpen);
        });
        group.addEventListener('keydown', event => {
          if (event.key === 'Escape' && group.open) {
            event.preventDefault();
            event.stopPropagation();
            setGroupOpen(false);
            summary.focus();
          }
        });
      });
    }
    const mobileQuery = window.matchMedia('(max-width: 1279px)');
    mobileQuery.addEventListener('change', event => {
      closeDesktop();
      if (!event.matches && drawer && drawer.open) {
        previousFocus = null;
        drawer.close();
      }
    });
    const header = document.querySelector('.site-header--compact');
    if (header) {
      let previousY = Math.max(0, window.scrollY);
      let movement = 0;
      let scrollFrame = null;
      let headerHeight = header.offsetHeight;
      let inspecting = Boolean(window.Shopify && window.Shopify.inspectMode);
      const revealHeader = () => {
        header.classList.remove('is-scroll-hidden');
        movement = 0;
      };
      const measureHeader = () => {
        headerHeight = header.offsetHeight;
        document.documentElement.style.setProperty('--nexa-header-height', headerHeight + 'px');
      };
      const updateScroll = () => {
        scrollFrame = null;
        const maxY = Math.max(0, document.documentElement.scrollHeight - window.innerHeight);
        const y = Math.max(0, Math.min(window.scrollY, maxY));
        const delta = y - previousY;
        previousY = y;
        header.classList.toggle('is-scrolled', y > 8);
        const interacting = Boolean(
          (drawer && drawer.open) || (searchPanel && searchPanel.open) ||
          header.querySelector('details[open]') || header.querySelector(':focus-visible')
        );
        if (!mobileQuery.matches || inspecting || interacting || y <= headerHeight + 16) {
          revealHeader();
          return;
        }
        if (delta === 0) return;
        movement = Math.sign(delta) === Math.sign(movement) ? movement + delta : delta;
        if (movement >= 16) header.classList.add('is-scroll-hidden');
        else if (movement <= -8) revealHeader();
      };
      const queueScroll = () => {
        if (scrollFrame === null) scrollFrame = window.requestAnimationFrame(updateScroll);
      };
      header.addEventListener('focusin', revealHeader);
      header.querySelectorAll('details').forEach(panel => panel.addEventListener('toggle', () => {
        if (panel.open) revealHeader();
      }));
      if (drawer) drawer.addEventListener('toggle', () => { if (drawer.open) revealHeader(); });
      window.addEventListener('scroll', queueScroll, { passive: true });
      window.addEventListener('resize', () => { measureHeader(); revealHeader(); queueScroll(); }, { passive: true });
      mobileQuery.addEventListener('change', () => { measureHeader(); revealHeader(); queueScroll(); });
      window.addEventListener('pageshow', () => { previousY = Math.max(0, window.scrollY); revealHeader(); queueScroll(); });
      document.addEventListener('shopify:inspector:activate', () => {
        inspecting = true;
        header.classList.add('is-inspecting');
        revealHeader();
      });
      document.addEventListener('shopify:inspector:deactivate', () => {
        inspecting = false;
        header.classList.remove('is-inspecting');
        queueScroll();
      });
      header.classList.toggle('is-inspecting', inspecting);
      if ('ResizeObserver' in window) new ResizeObserver(measureHeader).observe(header);
      measureHeader();
      updateScroll();
    }
    window.addEventListener('pagehide', () => {
      closeDesktop();
      if (drawer && drawer.open) {
        previousFocus = null;
        drawer.close();
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
